import 'core-js';
import fromEntries from 'object.fromentries';

if (Object.fromEntries === undefined) {
  Object.fromEntries = fromEntries;
}
